// replyMessage.js
'use strict';
import getOperationData from '../selector/getOperationData.js';
import getMessageData from '../selector/getMessageData.js';
import getUserData from '../selector/getUserData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

import checkChatMessageDraft from '../action/checkChatMessageDraft.js';
import setReplyMessageStatus from '../action/setReplyMessageStatus.js';
import sendChatStart from '../action/sendChatStart.js';
import setMessageReplyInputValue from '../action/setMessageReplyInputValue.js';
import prepareChatMessage from '../action/prepareChatMessage.js';

import sendMessageToCustomerService from '../resource/sendMessageToCustomerService.js';

import { CUSTOMER_SERVICE_ACCOUNT_UIDS } from '../RemoteConfigKeys.js';

/**
 * Reply message
 * @kind action
 * @param {string} {messageId} - which message id been replied.
 * @param {string} {text} - reply message text.
 * @param {object} {media} - reply message media.
 * @return {Promise} Action promise.
 */
const replyMessage =
  ({ messageId, text, media }) =>
  async (dispatch, getState) => {
    const replySelectPath = ['message', messageId];
    const isSending = getOperationData(
      getState(),
      replySelectPath,
      'replyIsSending'
    );
    if (!messageId || isSending) {
      return dispatch({ type: '' });
    }
    const senderId = getMessageData(getState(), messageId, 'senderId');
    const customerServiceAccountUids = getRemoteConfigData(
      getState(),
      CUSTOMER_SERVICE_ACCOUNT_UIDS
    );
    // Replies to customer service go to the messenger, never into a chatroom
    if (customerServiceAccountUids.includes(senderId)) {
      await sendMessageToCustomerService({ text });
      return dispatch(
        setMessageReplyInputValue({ messageId, text: '', media: null })
      );
    }
    try {
      dispatch(setReplyMessageStatus({ messageId, replyIsSending: true }));
      const replyPrice = getUserData(getState(), senderId, 'replyPrice');
      await dispatch(
        checkChatMessageDraft({
          text,
          media,
          replyPrice,
        })
      );
      await dispatch(sendChatStart({ userId: senderId }));
      const chatroomId = window.location.pathname.split('/').slice(-1)[0];
      dispatch(setMessageReplyInputValue({ messageId, text: '', media: null }));
      dispatch(setReplyMessageStatus({ messageId, replyIsSending: false }));
      return dispatch(
        prepareChatMessage({
          text,
          media,
          chatroomId,
          replyMessageId: messageId,
        })
      );
    } catch (error) {
      dispatch(setReplyMessageStatus({ messageId, replyIsSending: false }));
    }
  };

export default replyMessage;
